import axios from 'axios';

const API = axios.create({
  // Use a relative path so the browser calls "/api", which Nginx will forward
  // to http://localhost:4000/api (as configured in therapy.conf)
  baseURL: '/api'
});

// Attach token from localStorage to Authorization header
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default API;
